
<script>
export default {
  data:()=>(
    {
      // filter
      isShowFilterDialog: false,
      filterCondition: {
        // ProjectID: 0,
        // DepartmentID: 0,
        // UserID: 0,
        // Date: null
      },
    }
  ),
  computed: {
    filterConditionCount () {
      return Object.keys(this.filterCondition).reduce((sum, key) => {
        const val = this.filterCondition[key];
        if (Array.isArray(val)) return sum + (val.length > 0 ? 1 : 0);
        return sum + Boolean(val);
      }, 0);
    },
  },
  methods: {
    onFilterUpdated (obj) {
      this.filterCondition = JSON.parse(JSON.stringify(obj))
      this.reloadDataTable()
    }
  }
};
</script>
